import { inject, injectable } from '@wix/typesafe-inversify';
import type { ITranslations } from './ITranslations';
import { Services } from '../../ioc/services';
import type { IPlatformTranslations } from '../../types/PlatformTypes';

@injectable()
export class Translations implements ITranslations {
  constructor(
    @inject(Services.PlatformTranslations)
    private readonly platformTranslations: IPlatformTranslations,
  ) {}

  translate(key: string): string {
    return this.platformTranslations.t(key);
  }
}
